<template>
	<v-dialog v-model="dialog" persistent max-width="600" scrollable content-class="rounded-xl">
		<v-card>
			<v-card-title class="justify-space-between pb-0">
				<div class="font-size-13 secondary--text">Detail Stokis</div>
				<v-btn small text class="px-0 mr-n4" @click="modalHide">
					<v-icon color="red">mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text class="pt-3">
				<v-col class="px-0 cl-secondary font-size-11 font-weight-500 border-grey">
					<v-card class="py-3 elevation-0 rounded-xl h-100">
						<v-row>
							<v-col cols="12" sm="12" md="4">
								<div class="rounded-xl overflow-hidden">
									<v-img eager height="140px" :src="stockist.stockist_image ? stockist.stockist_image : require('/public/assets/image/user-pict.jpg')"></v-img>
								</div>
							</v-col>
							<v-col cols="12" sm="12" md="8">
								<div class="py-3">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<div class="font-size-16 product-name secondary--text" v-bind="attrs" v-on="on">{{ stockist.stockist_name }}</div>
										</template>
										<span style="font-size-16">{{ stockist.stockist_name }}</span>
									</v-tooltip>
									<div class="font-size-10 font-weight-bold cl-primary mb-2 mt-2">{{ stockist.stockist_code }}</div>
									<div class="pt-2 font-size-10 cl-grey">{{ stockist.stockist_address }}</div>
									<div class="pt-2 font-size-10 cl-grey">{{ stockist.stockist_subdistrict_name }} {{ ', ' + stockist.stockist_city_name }} {{ ', ' +stockist.stockist_province_name }}</div>
									<div class="pt-1 font-size-10 cl-grey">Email: {{ stockist.stockist_email }}</div>
									<div class="pt-1 font-size-10 cl-grey">Phone: {{ stockist.stockist_mobilephone }}</div>
									<div class="pt-1 font-size-10 cl-grey mt-2">Tgl Join: {{ stockist.stockist_join_date }}</div>
								</div>
							</v-col>
						</v-row>
					</v-card>
				</v-col>
			</v-card-text>
			<v-card-actions class="justify-center">
				<v-col cols="4">
					<v-btn depressed block color="primary" class="white--text rounded-xl text-capitalize" :loading="btnLoadingProses" :disabled="btnLoadingProses" @click="clearData">
						<v-icon small>mdi-close</v-icon>
						<span class="pl-1">Tutup</span>
					</v-btn>
				</v-col>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
	data () {
		return {
			dialog: false,
			searchDate: false,
			btnLoadingProses: false,
			params: {
				name: {
					type:'string',
					field:'stockist_name',
					comparison: '<>',
					value:''
				},
				code: {
					type:'string',
					field:'stockist_member_network_code',
					comparison: '<>',
					value:''
				},
				province: {
					type:'string',
					field:'stockist_province_id',
					comparison: '<>',
					value:''
				},
				city: {
					type:'string',
					field:'stockist_city_id',
					comparison: '<>',
					value:''
				},
			},
		}
	},
	computed:{
		...mapState('opsi', ['provinces', 'cities']),
	},
	props: {
		stockist: Object
	},
	methods :{
		...mapActions('opsi', ['getProvince', 'getCity']),

		changeProvince() {
			this.getCity({ province_id: this.params.province.value	})
			this.params.city.value = ''
		},
		modalShow() {
			this.dialog = true
			this.getProvince()
		},
		modalHide() {
			this.dialog = false
			this.btnLoadingProses = false
		},
		reset() {
			this.params.name.value = ''
			this.params.code.value = ''
			this.params.province.value = ''
			this.params.city.value = ''
		},
		async clearData() {
			this.btnLoadingProses = await true
			await this.$emit('action', this.params)
		},
	}
};
</script>